export default __webpack_public_path__ + "static/media/finland.3797f487.png";